import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from "@angular/router";
// @ts-ignore
import packageInfo from '../../../../package.json';
import {ToastService} from "../../services/toast.service";
import {ApiService} from "../../services/api.service";
import {firstValueFrom, isEmpty} from "rxjs";
import {ServerInfo} from "../../model/model";
import {AsyncPipe, NgIf} from "@angular/common";
import {OAuthService} from "angular-oauth2-oidc";
import {BlockUI, NgBlockUI} from "ng-block-ui";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
RouterLinkActive, RouterLink, AsyncPipe, NgIf
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements AfterViewInit{
  @BlockUI() blockUI!: NgBlockUI;

  constructor(
    private toastService: ToastService,
    private oauthService: OAuthService,
    private api: ApiService,
    private router: Router,
    // private storage: Storage
  ) {

  }

  utente: any;
  sVersion:string|undefined;
  public version: string = packageInfo.version;

  logOut() {
    this.oauthService.logOut();
    this.toastService.showSuccess("Logged out!");
  }

  cambiaRuolo() {

  }

  /*
  get givenName() {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      return null;
    }
    return claims['name'];
  }
  */

  getUtenteCharacters() {
    return this.userName
      .split(' ') // Divide la frase in parole
      .map((word: any[]) => word[0]) // Estrae la prima lettera di ogni parola
      .join('');
  }

  public get userName() {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      return null;
    }
    return claims['name'];
  }


  async serverVersion() {
    if(this.oauthService.getAccessToken()) {
      this.blockUI.start("Ottengo informazioni dal server");
      let si: ServerInfo | void | null= await firstValueFrom(this.api.getServerInfo()).catch(reason => null).finally(() => this.blockUI.stop());
      this.sVersion = (si && si.version) ? si.version : undefined;
    }
  }

  async ngAfterViewInit() {
      this.serverVersion();
      this.utente = await firstValueFrom(this.api.getUtente()).finally(this.blockUI.stop);
      sessionStorage.setItem("utente", JSON.stringify(this.utente));
  }

  ngOnDestroy() {
  }

  protected readonly isEmpty = isEmpty;
}
